<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    
    <vs-table ref="table"   v-model="selected" @selected="handleSelected" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">


          <!-- ADD NEW -->
          
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="nom_domaine">Domaine</vs-th>
        <vs-th sort-key="order_status">Votre Formations</vs-th>
        <vs-th sort-key="order_status">Votre participation</vs-th>
        <vs-th class="whitespace-no-wrap">Créances</vs-th>
      </template>
      
        <template slot-scope="{data}"> 
          <tbody>
            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-if="domaineFilter.value==='all' || tr.nom_domaine===domaineFilter.value ">
              <vs-td >
                <p  class="product-titre font-medium truncate">{{ tr.nom_domaine }}</p>
              </vs-td>
              
              <vs-td>
                <div class="vx-col flex-1 " id="account-info-col-2">
                <p ><span class="ml-5">{{tr.nb_formation_candidat}} de {{tr.nb_formation}} disponible</span></p>
                <div class="vx-col w-3/4 mb-3"><vs-progress class="block mt-1" :percent="Number(tr.nb_formation_candidat*100/tr.nb_formation)" :color="getPopularityColor(Number(tr.nb_formation_candidat*100/tr.nb_formation))"></vs-progress></div>
               </div>
              </vs-td>
              <vs-td>
                <div class="vx-col flex-1 " id="account-info-col-2">
                <p ><span class="ml-5">{{tr.nb_participation}} de {{tr.nb_participation_total}}</span></p>
                <div class="vx-col w-3/4 mb-3"><vs-progress class="block mt-1" :percent="Number(tr.nb_participation*100/tr.nb_participation_total)" :color="getPopularityColor(Number(tr.nb_participation*100/tr.nb_participation_total))"></vs-progress></div>
               </div>
              </vs-td>
              <vs-td>
                <p  class="product-titre font-medium truncate">{{tr.credi}} DT</p>
              </vs-td>
              
             
            </vs-tr>
          </tbody>
          
        </template>
    </vs-table>
  </div>
</template>

<script>
//import moduleformation from '@/store/formation/moduleformation.js'
import moduledomaine from '@/store/domaine/moduledomaine.js'
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data() {
    return {
      usersid:null,
      gridApi: null,
      gridOptions: {},
      domaineFilter: { label: 'All', value: 'all' },
      domaineOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' },
      ],
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
     
    }
  },
  computed: {
    
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products() {
      
      return this.$store.state.domaine.users
    },
    queriedItems() {
      
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
     /* let opt=this.products.length;
      for(let i=0;i<this.products.length;i++){
      {   
       if (this.products[0].name===this.domaineFilter.value){opt--}
      }}
      console.log('opt=',opt)
      return opt+1*/
    }
  },
 
  methods: {
    
    handleSelected(tr) {
      this.$router.push("/candidat/application/domaine/user-Vview/" + tr.id)
      //this.$router.push("/application/formation/user-Vview/" + this.params.tr.id).catch(() => {})
      
    },
    
    
    getOrderStatusColor(status) {
      if(status == 'on_hold') return "warning"
      if(status == 'delivered') return "success"
      if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    
    confirmDeleteRecord(nom,id) {
      this.usersid = id
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirm Delete`,
              text: `You are about to delete "${nom}"`,
              accept: this.deleteRecord,
              acceptText: "Delete"
            })
          },
          deleteRecord() {
            /* Below two lines are just for demo purpose */
            console.log('this.usersid',this.usersid)
            this.showDeleteSuccess()
            this.$store.dispatch("domaine/removeRecord", this.usersid)
            
          },
          showDeleteSuccess() {
            this.$vs.notify({
              color: 'success',
              title: 'Domaine Deleted',
              text: 'The selected domaine was successfully deleted'
            })
            
          }
  },
  created() {
    //this.$store.state.AppActiveUser.id
    if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
    console.log('120',this.$store.state.AppActiveUser.id)
   this.$store.dispatch("domaine/fetchDomainesCandidat",this.$store.state.AppActiveUser.id).catch(err => { console.error(err) })
    console.log('120',this.$store.state.domaine.users)

  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-nom {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        padding: 0 15px !important;
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
